<template>
    <el-dialog v-if="dialogFormVisible" v-el-drag-dialog class="select-ztree-dialog" :visible.sync="dialogFormVisible" custom-class="orgTreeDialog" :close-on-click-modal="false" :width="winWidth + 'px'" :title="dialogTitle" :append-to-body="true" @close="closeDialog">
        <div v-if="loading" v-loading="loading" class="el-dialog__body" style="height: 366px" />
        <div v-if="!loading" class="select-dialog-container">
            <el-row class="searchdoing" :gutter="20" :class="fontMagnify ? 'font-magnify' : ''">
                <el-col class="ztree-container" :span="12">
                    <el-row v-if="showSearchInput">
                        <el-col span="24" class="search-input-container">
                            <!-- <el-radio-group v-if="showSelectByTabs" v-model="selectByTabsActiveName" style="margin-bottom: 8px" size="small" @change="onSelectByTabsHandleClick">
                                <el-radio-button v-text-lbl="'byInstitution'" label="byOrg">按机构</el-radio-button>
                                <el-radio-button v-text-lbl="'byPosition'" label="byJobPosition">按岗位</el-radio-button>
                                <el-radio-button v-text-lbl="'byGroup'" label="byWorkgroup">按群组</el-radio-button>
                                <el-radio-button v-text-lbl="'byCommonGroup'" label="byPrivateWorkgroup">按常用组</el-radio-button>
                            </el-radio-group> -->
                            <el-input v-model="searchkey" size="small" :placeholder="$tx('ecwapp.SelectDialog.keyWords', '请输入搜索关键字')" @keyup.enter.native="searchTreeNode">
                                <el-button slot="append" icon="el-icon-search" @click.stop="searchTreeNode" />
                            </el-input>
                        </el-col>
                    </el-row>
                    <div class="treeNode">
                        <el-scrollbar tag="div" :style="{ height: showSelectByTabs && showSearchInput ? '307px' : showSearchInput ? '307px' : '348px' }">
                            <el-tree v-if="searchDoing" ref="searchOrgTree" :data="searchedData" :props="searchTreeProps" :empty-text="searchedData ? $tx('common.noData', '暂无数据') : $tx('ecwapp.SelectDialog.searching', '正在搜索...')" :show-checkbox="true" :check-strictly="checkStrictly" :node-key="nodeKey" :default-expanded-keys="defaultExpandedKeys" :default-checked-keys="defaultCheckedKeys" :filter-node-method="filterOrgTreeNode" @node-click="onTreeNodeClick" @check="onTreeNodeCheck">
                                <span slot-scope="{ data }" class="tree-node-icon">
                                    <i v-if="data.icon" :class="data.icon" />
                                    <span>{{ data.title }}</span>
                                </span>
                            </el-tree>
                            <el-tree v-if="!searchDoing && !switchTabPanel" ref="orgTree" :props="treeProps" :load="loadNode" :empty-text="$tx('common.noData', '暂无数据')" :lazy="lazy" :data="lazy ? null : treeData" :show-checkbox="true" :check-strictly="checkStrictly" :node-key="nodeKey" :default-expanded-keys="defaultExpandedKeys" :default-checked-keys="defaultCheckedKeys" :filter-node-method="filterOrgTreeNode" @node-click="onTreeNodeClick" @node-expand="onTreeNodeExpand" @check="onTreeNodeCheck">
                                <span slot-scope="{ data }" :class="'tree-node-icon'">
                                    <i v-if="data.icon" :class="data.icon" />
                                    <span>{{ data.name }}</span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </div>
                </el-col>
                <el-col class="ztree-container" :span="12">
                    <div class="selected-title">
                        <div v-text-lbl="'selected'" class="left" :dataType="selectedNodes.length || 0">已选择（{{ selectedNodes.length || 0 }}）</div>
                        <div v-if="showSelectByTabs">
                            <!-- <el-button v-text-lbl="'setCommonGroup'" size="mini" type="primary" @click="addFormShow">设为常用组</el-button> -->
                            </div>
                    </div>
                    <el-scrollbar class="treeNode" tag="div" style="height: calc(100% - 38px)">
                        <div class="selectedNodes">
                            <div v-for="(selectedNode, selectedNodeKey) in selectedNodes" :key="selectedNodeKey" class="selectedNode">
                                <div class="node-text" :title="selectedNode.staffFullName || selectedNode.title">{{ selectedNode.staffFullName || selectedNode.title }}</div>
                                <i :key="selectedNodeKey" class="el-icon-close" type="danger" @click="removeSelectedNode(selectedNode)" />
                            </div>
                            <div v-show="!selectedNodes || selectedNodes.length === 0" v-text-lbl="'noSelection'">暂无选择</div>
                        </div>
                    </el-scrollbar>
                </el-col>
            </el-row>
        </div>
        <el-dialog v-if="addFormVisible" v-el-drag-dialog class="select-ztree-dialog" :visible.sync="addFormVisible" :close-on-click-modal="false" :width="winWidth + 'px'" :title="$tx('ecwapp.SelectDialog.commonGroup', '常用组')" :append-to-body="true">
            <el-form :model="vo">
                <div style="width: 100%" class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td ref="tdlbl_常用组名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-text-lbl="'commonGroupName'">常用组名称</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <el-input v-model="commonGroupName" size="small" :placeholder="$tx('ecwapp.SelectDialog.inputCommonGroup', '请输入常用组名称')" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" plain icon="el-icon-close" @click="addFormVisible = false">关 闭</el-button>
                <el-button v-pageBtn-lbl="'save'" type="primary" icon="el-icon-check" @click="addForm">保 存</el-button>
            </div>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
            <el-button v-pageBtn-lbl="'cancel'" plain icon="el-icon-close" @click="closeDialog">取 消</el-button>
            <el-button v-pageBtn-lbl="'sure'" type="primary" icon="el-icon-check" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {},
    props: {
        winWidth: { type: Number, default: 623 }
    },
    data() {
        return {
            i18npkg: 'ecwapp',
            moduleCode: 'SelectDialog',
            dialogTitle: '', // 弹窗标题
            dialogName: null, // 弹窗Name
            dialogFormVisible: false,
            addFormVisible: false,
            commonGroupName: '', // 新增常用组名称
            loading: false,
            el: null,
            binding: null,
            vnode: null,
            callback: null, // 回调函数
            treeData: null, // 树数据
            treeDataMap: {}, // 树数据id-value
            defaultExpandedKeys: [], // 默认展开的节点ID
            defaultCheckedKeys: [], // 默认选中的节点ID
            byOrgTreeData: null, // 按机构选择树数据
            byWgTreeData: null, // 按群组选择树数据
            byJbTreeData: null, // 工按岗位选择树数据
            byPrivateWorkgroupData: null, // 按常用组选择树数据
            treeProps: {
                children: 'children',
                label: 'name',
                isLeaf: this.isLeafNode
            },
            searchTreeProps: {
                children: 'children',
                label: 'title',
                isLeaf: this.isLeafNode
            },
            lazy: false,
            switchTabPanel: false,
            checkStrictly: true, // 是否严格的遵循父子不互相关联的做法
            multiple: false, // 是否多选
            onebyone: false, // 每部门/每组限选一人
            prevSelected: [],
            searchkey: '', // 搜索
            searchedData: null, // 搜索结果
            selectedNodes: [], // 已选择数据
            selectedOrderBy: 'orgOrderNo', // 多选人员排序方式，默认按组织机构人员排序
            isStaffExt: false, // 是否人员选择扩展模式
            rootTreeData: null, // 人员选择扩展部门数据
            selectRootOrg: -1, // 被选择的公司
            rootOrgList: [], // 所有公司列表
            subOrgList: {}, // 已加载子机构
            searchDoing: false,
            indeterminate: false,
            showSelectAllNodes: false, // 是否显示全选复选框
            selectAllNodes: false, // 全选状态
            showSearchInput: true, // 是否显示搜索框
            fontMagnify: false, // 是否自定义标题字体
            openSysCode: '', // 仅显示开通指定系统的人员
            showSelectByTabs: false, // 是否显示按机构、按群组、按岗位选择人员切换标签，仅选择单位全体人员时有效
            selectByTabsActiveName: 'byOrg',
            tabType: '',
            staffExtOrgCode: '',
            staffExtOldValue: '',
            elLevel: '',
            isSelf: false,
            nodeKey: 'id'
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {},
    created() {
        this.$bus.on('RsglOpenSelectDialog', this.openSelectDialog)
    },
    beforeDestroy() {
        this.$bus.off('RsglOpenSelectDialog', this.openSelectDialog)
    },
    mounted() {},
    methods: {
        async openSelectDialog(el, binding, vnode) {
            const _this = this
            if (_this.loading) {
                return
            }
            if (window.fontMagnify) this.fontMagnify = true
            this.loading = true
            this.dialogFormVisible = true
            this.isStaffExt = false
            this.searchedData = null
            this.searchDoing = false
            this.checkStrictly = true
            this.showSelectByTabs = false
            this.selectByTabsActiveName = 'byOrg'
            this.defaultCheckedKeys = []
            this.defaultExpandedKeys = []
            this.el = el
            this.binding = binding
            this.vnode = vnode
            this.multiple = el.attrs.multiple
            this.lazy = this.isLazy()
            this.selectedOrderBy = el.attrs['selected-order-by'] || this.selectedOrderBy

            let searchInput = null
            if (el.attrs['search-input'] === 'true') searchInput = true
            if (el.attrs['search-input'] === 'false') searchInput = false

            if (this.multiple === 'true') this.multiple = true
            if (this.multiple === 'false') this.multiple = false

            if (binding.value === 'wfNodeUser' || binding.value.toUpperCase().indexOf('STAFF') !== -1 || (binding.value === 'suborg' && this.multiple)) {
                this.checkStrictly = false // 流程选择处理人允许级联
            }

            if (el.attrs.onebyone === '1') {
                this.onebyone = true
            } else {
                this.onebyone = false
            }

            if (el.attrs['dialog-width'] && !isNaN(Number(el.attrs['dialog-width']))) this.winWidth = Number(el.attrs['dialog-width'])

            let reqParams = null
            if (!this.multiple || this.multiple === 'false' || el.attrs.onebyone === '1') {
                this.showSelectAllNodes = false
            } else if (binding.value === 'staff' || binding.value === 'wfNodeUser' || binding.value === 'workgroupStaff' || binding.value === 'jobPositionStaff') {
                this.showSelectAllNodes = true
            } else {
                this.showSelectAllNodes = false
            }

            if (el.attrs['checkall-checkbox'] === 'true') this.showSelectAllNodes = true
            if (el.attrs['checkall-checkbox'] === 'false') this.showSelectAllNodes = false

            if (binding.value === 'staff' && el.attrs['org-level'] === '0') {
                binding.value = 'staffExt'
            }
            _this.isSelf = el.attrs['org-self']
            if (binding.value === 'allStaff' || binding.value === 'allOrg' || binding.value === 'allNode' || binding.value === 'curOrgNode') {
                this.winWidth = 700

                if (binding.value === 'allStaff') {
                    this.dialogTitle = this.$tx('common.selectPerson', '选择人员')
                    this.callback = 'onSelectStaffCompleted'
                    this.showSelectByTabs = true
                } else if (binding.value === 'allOrg') {
                    this.dialogTitle = this.$tx('common.selectOrg', '选择机构')
                    this.callback = 'onSelectAllOrgCompleted'
                } else {
                    this.dialogTitle = this.$tx('common.selectOrg', '选择机构人员')
                    this.callback = 'onSelectAllNodeCompleted'
                    if (el.attrs['org-level'] === '8') {
                        this.showSelectByTabs = true
                    }
                }
                this.dialogName = 'treeDialog'

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findTreeNodeVOListByNodeId', // 加载目录树节点(TreeNode对象)url
                    params: { status: 1 } // 查询条件
                }
                this.elLevel = el.attrs['org-level']
                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }
                if (binding.value === 'curOrgNode') {
                    // 单位内机构、人员混选
                    reqParams.url = 'base/organMgr/findTreeNodeVOListByOrgCode'
                    reqParams.params['orgCode'] = orgCode
                    this.staffExtOrgCode = orgCode
                    this.showSelectByTabs = true
                } else if (binding.value === 'allNode' && el.attrs['org-level'] === '0') {
                    // 集团内单位人员混选
                    reqParams.url = 'base/organMgr/findGroupOrganByOrgCode'
                    reqParams.params['orgCode'] = orgCode
                    this.staffExtOrgCode = orgCode
                    this.showSelectByTabs = true
                }

                // 树节点级别
                if (el.attrs['node-level']) {
                    reqParams.params['nLevelFilter'] = Number(el.attrs['node-level'])
                }
                // 节点ID
                if (el.attrs['node-id']) {
                    reqParams.params['nodeId'] = el.attrs['node-id']
                    reqParams.params['self'] = true
                }
                if (el.attrs['org-self']) {
                    reqParams.params['self'] = el.attrs['org-self']
                }
            } else if (binding.value === 'treeNode' || binding.value === 'area') {
                this.dialogTitle = binding.value === 'area' ? this.$tx('ecwapp.SelectDialog.selectRegion', '选择行政区域') : this.$tx('ecwapp.SelectDialog.selectDirectory', '选择机构目录')
                this.dialogName = 'treeDialog'

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findTreeNodeVOListByNodeId', // 加载目录树节点(TreeNode对象)url
                    params: { type: binding.value, status: 1 } // 查询条件
                }
                // 树节点级别
                if (el.attrs['node-level']) {
                    reqParams.params['nLevelFilter'] = Number(el.attrs['node-level'])
                }
                // 节点ID
                if (el.attrs['node-id']) {
                    reqParams.params['nodeId'] = el.attrs['node-id']
                    reqParams.params['self'] = true
                }

                this.callback = 'onSelectTreeNodeCompleted'
            } else if (binding.value === 'rootorg') {
                this.dialogTitle = this.$tx('common.selectOrg', '选择机构')
                this.dialogName = 'treeDialog'

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findTreeNodeVOListByNodeId', // 加载目录树节点(TreeNode、Oragnization两类对象)url
                    params: { status: 1 } // 查询条件
                }
                // 节点级别
                if (el.attrs['node-level']) {
                    reqParams.params['nLevelFilter'] = Number(el.attrs['node-level'])
                }
                // 节点ID
                if (el.attrs['node-id']) {
                    reqParams.params['nodeId'] = el.attrs['node-id']
                    reqParams.params['self'] = true
                }
                // 主机构类别
                if (el.attrs['org-type']) {
                    reqParams.params['orgType'] = Number(el.attrs['org-type'])
                }

                this.callback = 'onSelectRootorgCompleted'
            } else if (binding.value === 'suborg') {
                this.dialogTitle = this.$tx('common.selectDepart', '选择部门')
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                //可能多选时，显示根机构
                const params = { orgCode: orgCode, self: this.multiple }
                if (el.attrs['org-level'] !== undefined) {
                    if (el.attrs['org-level'] === '') el.attrs['org-level'] = '2,3,4' // 为空表示不限制
                    const orgLevel = el.attrs['org-level'].split(',')
                    params.subOrgLevel = orgLevel[orgLevel.length - 1]
                }
                reqParams = {
                    method: 'POST',
                    url: 'xsgl/organization/querydata', // 加载部门/科室/班组树节点(Oragnization)url
                    data: [],
                    params: { orderBy: 'orgLevel,orderNo asc' } // 查询条件
                }
                this.callback = 'onSelectSuborgCompleted'
            } else if (binding.value === 'workgroup') {
                this.dialogTitle = this.$tx('ecwapp.SelectDialog.selectWorkGroup', '选择工作群组')
                this.dialogName = 'listitemDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'POST',
                    url: 'base/workGroup/querydata', // 加载工作群组列表(WorkGroup对象)url
                    data: [
                        { field: 'orgCode', compare: '=', value: orgCode },
                        { field: 'status', compare: '=', value: 1 }
                    ] // 查询条件
                }

                this.callback = 'onSelectWorkgroupCompleted'
            } else if (binding.value === 'jobPosition') {
                this.dialogTitle = this.$tx('ecwapp.SelectDialog.selectJobPosition', '选择工作岗位')
                this.dialogName = 'listitemDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'POST',
                    url: 'base/jobPosition/querydata', // 加载工作岗位列表(JobPosition对象)url
                    data: [
                        { field: 'orgCode', compare: '=', value: orgCode },
                        { field: 'status', compare: '=', value: 1 }
                    ] // 查询条件
                }

                this.callback = 'onSelectJobPositionCompleted'
            } else if (binding.value === 'staff') {
                this.dialogTitle = this.$tx('common.selectPerson', '选择人员')
                this.dialogName = 'treeDialog'
                const treeData = this.el.attrs['init-tree-data']
                if (treeData === undefined) {
                    const orgId = this.el.attrs['org-id']
                    const orgLevel = this.el.attrs['org-level']
                    const subOrgName = this.el.attrs['sub-org-name']
                    const orgSelf = this.el.attrs['org-self']
                    let orgCode = this.el.attrs['root-org-code']

                    if (orgCode === undefined) {
                        orgCode = this.loginUser.orgCode
                    }

                    if (orgLevel === 1 || orgLevel === '1') {
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrgLeaderByOrgCode', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgCode: orgCode, self: orgSelf } // 查询条件
                        }
                    } else if (orgLevel === 2 || orgLevel === '2') {
                        this.orgId = ''
                        if (vnode.context.$parent.curTN) {
                            this.orgId = vnode.context.$parent.curTN.staffOrgID.split('-')[1]
                        } else {
                            this.loginUser.staffList.forEach((staff) => {
                                this.orgId += (this.orgId === '' ? '' : ',') + staff.orgFullId.split('-')[1]
                            })
                        }
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonByOrgId', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgId: this.orgId, self: orgSelf } // 查询条件
                        }
                    } else if (orgId !== undefined && orgId !== null && orgId !== '') {
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonByOrgId', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgId: orgId, self: orgSelf } // 查询条件
                        }
                    } else if (subOrgName !== undefined && subOrgName !== null && subOrgName !== '') {
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonBySubOrgName', // 加载部门/科室/班组树节点(Oragnization)url
                            params: { orgCode: orgCode, subOrgName: subOrgName, self: orgSelf } // 查询条件
                        }
                    } else {
                        reqParams = {
                            method: 'GET',
                            url: 'rsgl/archiveInfo/findArchiveInfoOrganPersonByOrgCode', // 加载部门/科室/班组树节点(Oragnization)url
                            // params: { orgCode: orgCode, self: orgSelf } // 查询条件
                            params: { orgCode: orgCode } // 查询条件
                        }
                        this.showSelectByTabs = true
                    }
                }

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'jobPositionStaff') {
                this.dialogTitle = this.$tx('common.selectPerson', '选择人员')
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findOrganPersonByJobPosition', // 加载工作岗位人员url
                    params: { orgCode: orgCode, jobPositionCode: this.el.attrs['job-position-code'] } // 查询条件
                }

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'workgroupStaff') {
                this.dialogTitle = this.$tx('common.selectPerson', '选择人员')
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }

                reqParams = {
                    method: 'GET',
                    url: 'base/organMgr/findOrganPersonByWorkgroup', // 加载工作群组成员url
                    params: { orgCode: orgCode, workgroupCode: this.el.attrs['workgroup-code'] } // 查询条件
                }

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'wfNodeUser') {
                this.dialogTitle = this.$tx('common.selectPerson', '选择人员')
                this.dialogName = 'treeDialog'
                this.showSelectByTabs = this.el.attrs['show-select-by-tabs']

                let asyncOrgId = ''
                const wfNodeUsers = this.el.attrs['init-tree-data']
                wfNodeUsers.forEach((wfUser) => {
                    if (wfUser.type === 'asyncLoadingUsers') {
                        asyncOrgId += (asyncOrgId === '' ? '' : ',') + (wfUser.orgId || wfUser.parentId)
                    }
                })

                if (asyncOrgId !== '') {
                    delete _this.el.attrs['init-tree-data']
                    if (asyncOrgId === 'group') {
                        // 全集团
                        let orgCode = this.el.attrs['root-org-code']
                        if (orgCode === undefined) {
                            orgCode = this.loginUser.orgCode
                        }

                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonForGroupOrg',
                            params: { orgCode: orgCode } // 查询条件
                        }
                    } else {
                        // 指定机构ID
                        reqParams = {
                            method: 'GET',
                            url: 'base/organMgr/findOrganPersonByOrgId',
                            params: { orgId: asyncOrgId, self: asyncOrgId.split(',').length > 1 } // 查询条件
                        }
                    }
                } else if (this.multiple && this.el.attrs['todo-mode'] !== '3' && wfNodeUsers.length > 0 && wfNodeUsers[0].personId) {
                    //增加“全选人员”跟节点
                    const suborgs = wfNodeUsers.filter((u) => {
                        return !u.personId
                    })
                    if (suborgs.length === 0) {
                        const root = { name: '全部人员', id: '0', orgFullName: '全部人员', orgFullId: '0', orgLevel: 2, type: 'subOrg', passenger: {} }
                        wfNodeUsers.forEach((u) => {
                            u.groupId = '0'
                        })
                        wfNodeUsers.splice(0, 0, root)
                    }
                }

                this.callback = 'onSelectWfNodeUserCompleted'
            } else if (binding.value === 'staffExt') {
                this.dialogTitle = this.$tx('ecwapp.SelectDialog.selectPersonnelExtend', '选择人员(扩展)')
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']

                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }
                const oldValue = this.vnode.data.attrs['old-value'] || ''
                this.staffExtOrgCode = orgCode
                this.staffExtOldValue = oldValue
                reqParams = {
                    url: 'base/organMgr/findGroupOrganByOrgCode',
                    method: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    params: { orgCode: orgCode },
                    data: oldValue.split(',')
                }

                this.showSelectByTabs = true

                this.callback = 'onSelectStaffCompleted'
            } else if (binding.value === 'suborgExt') {
                this.dialogTitle = this.$tx('ecwapp.SelectDialog.selectDepartmentExtend', '选择部门(扩展)')
                this.dialogName = 'treeDialog'

                let orgCode = this.el.attrs['root-org-code']
                if (orgCode === undefined) {
                    orgCode = this.loginUser.orgCode
                }
                const params = { orgCode: 'group_all_corp:' + orgCode, subOrgLevel: 2 }
                if (el.attrs['org-level'] !== undefined) {
                    const orgLevel = el.attrs['org-level'].split(',')
                    params.subOrgLevel = orgLevel[orgLevel.length - 1]
                }

                reqParams = {
                    url: 'rsgl/organization/querydata',
                    data: [],
                    method: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    params: { orderBy: 'orgLevel,orderNo asc' }
                }

                this.callback = 'onSelectSuborgCompleted'
            } else {
                this.dialogName = el.attrs['dialog-class'] || 'treeDialog'
                this.callback = 'on' + binding.value[0].toUpperCase() + binding.value.substring(1) + 'Completed'
            }

            if (el.attrs['dialog-title'] !== undefined) {
                this.dialogTitle = el.attrs['dialog-title']
            }
            if (_this.el.attrs['option-generate-url'] && _this.el.attrs['option-generate-url'] !== '') {
                reqParams = {
                    method: _this.el.attrs['option-generate-gethod'] || 'get', // option-generate-gethod
                    url: _this.el.attrs['option-generate-url'] // 加载url
                }
            }
            if (!_this.multiple && (this.callback === 'onSelectStaffCompleted' || this.callback === 'onSelectAllNodeCompleted')) {
                _this.nodeKey = 'nodeKeyId'
            } else {
                _this.nodeKey = 'id'
            }

            if (_this.el.attrs['init-tree-data']) {
                const listdata = _this.filterEmputyNode(_this.el.attrs['init-tree-data'])
                _this.treeData = _this.treeDataAdapter(listdata)
                this.showSearchInput = searchInput !== null ? searchInput : this.treeData.filter((node) => !node.personId).length > 1 || (this.treeData.length > 0 && this.treeData[0].children)
                _this.$nextTick(() => {
                    _this.loading = false
                })
            } else if (reqParams !== null) {
                if (el.attrs['only-cur-sys'] !== 'false' && el.attrs['only-cur-sys'] !== false) {
                    this.openSysCode = ''
                    if (vnode.context.$parent.wfInstance) {
                        this.openSysCode = vnode.context.$parent.wfInstance.sysCode
                    } else if (vnode.context.process && vnode.context.process.sysCode) {
                        this.openSysCode = vnode.context.process.sysCode
                    } else if (vnode.context.vo && vnode.context.vo.sysCode) {
                        this.openSysCode = vnode.context.vo.sysCode
                    } else if (this.loginUser.sysCode !== 'eccloud') {
                        this.openSysCode = this.loginUser.sysCode
                    }

                    if (this.openSysCode && reqParams.params) reqParams.params.openSysCode = this.openSysCode
                }

                this.$http(reqParams).then((res) => {
                    if (res.code === 'success') {
                        if (binding.value === 'rootorg' || binding.value === 'allNode' || binding.value === 'allOrg' || binding.value === 'allStaff' || binding.value === 'staffExt' || binding.value === 'suborgExt') {
                            const listdata = this.filterEmputyNode(res.body.listdata)

                            _this.treeData = _this.treeDataAdapter(listdata)
                            _this.showSearchInput = searchInput !== null ? searchInput : this.treeData.filter((node) => !node.personId).length > 1 || (this.treeData.length > 0 && this.treeData[0].children)
                        } else {
                            _this.treeData = _this.treeDataAdapter(res.body.listdata)
                            _this.showSearchInput = searchInput !== null ? searchInput : this.treeData.filter((node) => !node.personId).length > 1 || (this.treeData.length > 0 && this.treeData[0].children)
                        }
                    } else {
                        this.$alert(res.message, { type: 'error' })
                    }

                    _this.$nextTick(() => {
                        _this.loading = false
                        if (_this.lazy && this.prevSelected.length > 0 && this.prevSelected[0] !== '') {
                            this.lazyLoadDefaultChecked(this.prevSelected)
                        }
                    })
                })
            }
        },
        isLazy() {
            let lazy = false
            const binding = this.binding.value
            if (binding === 'allStaff' || binding === 'allOrg' || binding === 'allNode' || binding === 'curOrgNode' || binding === 'staffExt') {
                if (!this.el.attrs['option-generate-url'] && !this.el.attrs['init-tree-data']) {
                    lazy = true
                }
            }
            return lazy
        },
        filterEmputyNode(listdata) {
            const nodeIds = []
            for (let i = 0; i < listdata.length; i++) {
                const node = listdata[i]
                if (node.type === 'rootOrg' || (node.orgLevel === 1 && node.orgFullId && node.orgFullId.indexOf('-') !== -1)) {
                    const fullIds = (node.fullID || node.orgFullId || '').split('-')
                    if (fullIds.length > 1) {
                        node.isLeaf = 1

                        fullIds.forEach((id) => {
                            if (nodeIds.indexOf(id) === -1) {
                                nodeIds.push(id)
                            }
                        })
                    } else {
                        // 未关联treeNode的根机构，不显示
                        listdata.splice(i--, 1)
                    }
                }
            }

            return listdata.filter((node) => {
                // 过滤掉不包含机构的目录树节点
                if (node.type !== 'treeNode' || nodeIds.indexOf(node.id) !== -1) {
                    return true
                }
            })
        },
        treeDataAdapter(allTreeData) {
            const _this = this
            const attr = this.el.attrs
            let treeData = JSON.parse(JSON.stringify(allTreeData))

            if (this.vnode.context.onSelectTreeDataLoaded) {
                treeData = this.vnode.context.onSelectTreeDataLoaded(treeData, attr)
            } else if (this.vnode.context.$vnode.context.onSelectTreeDataLoaded) {
                treeData = this.vnode.context.$vnode.context.onSelectTreeDataLoaded(treeData, attr)
            } else if (this.$vnode.context.$vnode.context.$vnode.context.onSelectTreeDataLoaded) {
                treeData = this.vnode.context.$vnode.context.$vnode.context.onSelectTreeDataLoaded(treeData, attr)
            }

            // 已经选择的值
            if (!this.tabType) {
                this.prevSelected = this.getPrevSelected()
            } else {
                this.prevSelected = []
            }
            for (let i = 0; i < treeData.length; i++) {
                const node = treeData[i]

                this.treeDataMap[node.id] = node

                node.checked = false
                if (node.type) node.type = node.type.replace(/\s*/g, '')

                if (node.personId) {
                    if (node.collapse === true && !_this.onebyone) {
                        for (let j = 0; j < treeData.length; j++) {
                            if (treeData[j].id === node.groupId || treeData[j].id === node.parentId || treeData[j].id === node.orgId) {
                                const collapseNodes = treeData[j].collapseNodes || []
                                if (attr.onebyone !== '1' || collapseNodes.length === 0) {
                                    collapseNodes.push(node)
                                    treeData[j].collapseNodes = collapseNodes

                                    treeData.splice(i--, 1)
                                }
                                break
                            }
                        }
                    } else {
                        node.pId = node.groupId || node.parentId || node.orgId
                        node.nodeKeyId = node.id + node.pId
                        // node.icon = this.user
                        node.canSelect = true
                        if (attr.showmobile === true || attr.showmobile === 'true') {
                            if (!node.mobile) node.mobile = '无'
                            node.name = node.name + '<' + (node.mobile === null ? '无' : node.mobile) + '>'
                            node.title = node.name
                        }
                        if (attr.showemail === true || attr.showemail === 'true') {
                            if (!node.email) node.email = '无'
                            node.name = node.name + '<' + node.email + '>'
                            node.title = node.name
                        }
                        if (attr.showaccount === true || attr.showaccount === 'true') {
                            if (!node.account) node.account = '无'
                            node.name = node.name + '<' + node.account + '>'
                            node.title = node.name
                        }

                        if (!node.title) {
                            let pname = (node.fullName || node.orgFullName).replace(/[&\|\\\*^%$#@\-]/g, '-')
                            pname = pname.substring(node.orgFullName.indexOf('-') + 1)
                            node.title = pname + '\\' + node.name
                        }

                        if (this.binding.value === 'allStaff' || this.binding.value === 'allNode' || this.binding.value === 'staffExt') {
                            node.title = node.name + ' ' + node.orgFullName
                        } else if (this.binding.value === 'curOrgNode') {
                            node.title = node.name + ' ' + node.orgFullName.substring(node.orgFullName.indexOf('-') + 1)
                        }
                    }
                } else if (this.binding.value === 'allStaff' || this.binding.value === 'staff' || this.binding.value === 'staffExt' || this.binding.value === 'allOrg' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode' || this.binding.value === 'treeNode' || this.binding.value === 'area' || this.binding.value === 'rootorg' || this.binding.value === 'wfNodeUser' || this.binding.value === 'jobPositionStaff' || this.binding.value === 'workgroupStaff') {
                    // 选择机构目录、主机构
                    node.pId = node.pId || node.parentID || node.parentId || node.treeId || -1
                    node.nodeKeyId = node.id + node.pId
                    node.name = node.nName || node.name

                    if (!this.multiple && this.binding.value.toUpperCase().indexOf('STAFF') !== -1) {
                        node.disabled = true
                    } else if (this.binding.value === 'allOrg' && node.type === 'treeNode') {
                        node.disabled = true
                    }

                    if (this.searchkey || node.type === 'subOrg') {
                        node.title = (node.fullName || node.orgFullName).replace(/[&\|\\\*^%$#@\-]/g, '-')
                    } else if (this.binding.value === 'wfNodeUser' && !node.personId) {
                        node.title = node.orgFullName.substring(node.orgFullName.indexOf('-') + 1)
                    } else {
                        node.title = node.name
                    }

                    if (this.binding.value === 'rootorg') {
                        if (node.type === 'treeNode') {
                            // node.icon = 'el-icon-folder'
                            node.disabled = true
                        } else {
                            node.canSelect = true
                        }
                    } else if (this.binding.value === 'allOrg' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode' || this.binding.value === 'treeNode' || this.binding.value === 'area') {
                        node.canSelect = true
                    } else if (this.binding.value === 'wfNodeUser' && !node.collapse && (!this.multiple || this.onebyone || this.selectedOrderBy === 'selectedIndex')) {
                        node.disabled = true
                    } else if (this.binding.value === 'allStaff' || this.binding.value === 'staffExt') {
                        if (node.type === 'treeNode') {
                            // node.icon = 'el-icon-folder'
                            node.disabled = true
                        }
                    }

                    if (node.orgFullId && !node.orgLevel && !node.olevel) {
                        node.orgLevel = node.orgFullId.split('-').length
                    }
                } else if (this.binding.value === 'suborg' || this.binding.value === 'suborgExt') {
                    // 选择部门/科室/班组
                    let levels = attr['org-level']
                    if (levels === undefined) {
                        attr['org-level'] = '2'
                        levels = '2'
                    } else {
                        levels = levels.split(',')
                    }

                    node.pId = node.parentId || node.parentID || node.parentId || node.treeId || -1
                    node.nodeKeyId = node.id + node.pId
                    node.title = node.orgFullName || node.fullName
                    node.name = node.name || node.nName
                    node.title = node.title.replace(/[&\|\\\*^%$#@\-]/g, '-')

                    if (this.binding.value === 'suborg' && node.title.indexOf('-') !== -1) {
                        node.title = node.title.substring(node.title.indexOf('-') + 1)
                    }

                    if (attr['org-level'].indexOf(node.orgLevel + '') === -1 && attr['org-level'].indexOf(node.olevel + '') === -1 && !this.multiple) {
                        node.disabled = true
                    }

                    if (node.orgLevel === 1 || node.olevel === 1) {
                        // 第一级打开
                        node.open = true
                    } else if (attr['org-level'].indexOf(node.orgLevel + '') !== -1 || attr['org-level'].indexOf(node.olevel + '') !== -1) {
                        // 允许选择
                        if (node.isRealOrg !== 0) {
                            node.canSelect = true
                        }
                    } else if (node.orgLevel > levels[levels.length - 1] || node.olevel > levels[levels.length - 1]) {
                        // 小于指定的机构级别，删除
                        treeData.splice(i--, 1)
                    }
                } else {
                    // 选择(工作岗位、组织机构)列表
                    node.title = node.title || node.name
                    node.canSelect = node.canSelect === true || node.canSelect === false ? node.canSelect : true
                    node.icon = node.icon || ''
                    node.pId = node.pId || node.parentId || ''
                    node.nodeKeyId = node.id + node.pId
                    this.showIcon = node.showIcon === true || node.showIcon === false ? node.showIcon : false
                    this.showLine = node.showLine === true || node.showLine === false ? node.showLine : false
                }

                // 默认选中项，优先取$scope.passenger，不存在则取value值
                if (node.canSelect || node.collapse) {
                    const vo = this.vnode.data.model.expression.split('.')[0]
                    const passenger = this.vnode.context[vo] ? this.vnode.context[vo].passenger : null
                    if (passenger && passenger[attr.name]) {
                        if (passenger[attr.name] instanceof Array) {
                            for (let pIndex = 0; pIndex < passenger[attr.name].length; pIndex++) {
                                if (passenger[attr.name][pIndex].id === node.id) {
                                    node.checked = true
                                    break
                                }
                            }
                        } else if (passenger[attr.name].indexOf(node.id) !== -1) {
                            node.checked = true
                        }
                    } else if (this.prevSelected.length > 0 && this.prevSelected[0] !== '') {
                        for (let j = 0; j < this.prevSelected.length; j++) {
                            let selected = this.prevSelected[j]

                            let title = node.title || node.name
                            if (selected.indexOf('\\') === -1 && title.indexOf('\\') > 0) {
                                title = title.substring(title.lastIndexOf('\\') + 1)
                            } else if (selected.indexOf(' ') !== -1 && selected.indexOf(node.account) !== -1) {
                                selected = selected.split(' ')[1]
                            }

                            const account = node.name + '/' + node.account
                            if (selected === node.id || selected === node.orgFullName || selected === node.title || selected === node.personId || (selected === node.name && this.binding.value !== 'suborgExt') || selected === title || selected === account || (node.code && selected === node.code)) {
                                node.checked = true
                                node.selectedIndex = j
                                this.prevSelected[j] = 'removed'
                                // this.prevSelected.splice(j--, 1)
                                break
                            }
                        }
                    }

                    if (node.checked) {
                        const selectedNode = _this.selectedNodes.filter((tnode) => {
                            return node.id === tnode.id || (node.personId && tnode.personId === node.personId)
                        })

                        if (selectedNode.length === 0) {
                            _this.selectedNodes.push(node)
                            _this.defaultCheckedKeys.push(node[_this.nodeKey])
                        }
                    }
                }
            }
            if (!this.lazy) {
                // 转换成树结构
                const level1Data = this.getChildren(treeData, null)
                if (level1Data.length > 0) {
                    level1Data.forEach((data) => {
                        data.children = this.getChildren(treeData, data)
                    })

                    if (level1Data.length === 1) {
                        _this.defaultExpandedKeys.push(level1Data[0][_this.nodeKey])
                    }
                }

                treeData = level1Data
            }

            if (this.showSelectByTabs === true) {
                if (this.selectByTabsActiveName === 'byOrg' && !this.byOrgTreeData) {
                    this.byOrgTreeData = JSON.parse(JSON.stringify(treeData))
                } else if (this.selectByTabsActiveName === 'byWorkgroup' && !this.byWgTreeData) {
                    this.byWgTreeData = JSON.parse(JSON.stringify(treeData))
                } else if (this.selectByTabsActiveName === 'byJobPosition' && !this.byJbTreeData) {
                    this.byJbTreeData = JSON.parse(JSON.stringify(treeData))
                } else if (this.selectByTabsActiveName === 'byPrivateWorkgroup' && !this.byPrivateWorkgroupData) {
                    this.byPrivateWorkgroupData = JSON.parse(JSON.stringify(treeData))
                }
            }

            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        },
        lazyLoadDefaultChecked(oldValue) {
            let orgCode = this.el.attrs['root-org-code']
            if (orgCode === undefined) {
                orgCode = this.loginUser.orgCode
            }

            oldValue = oldValue.filter((v) => {
                return v !== 'removed'
            })
            const _this = this
            if (oldValue.length > 0) {
                const reqParams = { method: 'POST', url: 'base/organMgr/findLazyLoadDefaultChecked', contentType: 'application/x-www-form-urlencoded', data: oldValue, params: { selectType: this.binding.value, orgCode: orgCode } }
                this.$http(reqParams).then((res) => {
                    if (res.code === 'success') {
                        _this.treeDataAdapter(res.body.listdata) // 数据格式化时会追加到已选择列表

                        if (_this.defaultExpandedKeys.length === 0) {
                            const rootIds = []
                            res.body.listdata.forEach((item) => {
                                if (item.orgFullId && rootIds.indexOf(item.orgFullId.split('-')[0])) {
                                    rootIds.push(item.orgFullId.split('-')[0])
                                }
                            })
                            rootIds.forEach((rootId) => {
                                const treeNode = _this.$refs.orgTree.getNode(rootId)
                                if (treeNode && !treeNode.loaded) {
                                    _this.defaultExpandedKeys.push(treeNode.data[_this.nodeKey])
                                }
                            })

                            _this.switchTabPanel = true
                            _this.$nextTick(() => {
                                //第一次更新，通过展开根节点，勾选节点树选择状态
                                _this.switchTabPanel = false

                                _this.$nextTick(() => {
                                    _this.defaultExpandedKeys = []
                                    _this.switchTabPanel = true
                                    //第二次更新，默认不展开节点
                                    _this.$nextTick(() => {
                                        _this.switchTabPanel = false
                                    })
                                })
                            })
                        }
                    }
                })
            }
        },
        // 查询子节点
        loadNode(node, loadResolve) {
            const _this = this
            new Promise((resolve, reject) => {
                if (node.data && (node.data.type === 'rootOrg' || node.data.orgLevel === 1) && _this.binding.value !== 'rootorg' && node.childNodes.length === 0) {
                    let reqParams = null
                    if (this.binding.value === 'allStaff' || this.binding.value === 'staffExt') {
                        const orgCode = node.data.ocode || node.data.code
                        reqParams = { method: 'GET', url: 'rsgl/archiveInfo/findArchiveInfoOrganPersonByOrgCode',
                        // params: { orgCode: orgCode, self: false, status: 1 } }
                            params: { orgCode: orgCode } }
                    } else {
                        reqParams = { method: 'GET', url: 'base/organMgr/findTreeNodeVOListByOrgId', params: { orgId: node.data.id, self: false, status: 1 } }
                    }

                    if (this.openSysCode) reqParams.params.openSysCode = this.openSysCode

                    this.$http(reqParams).then((res) => {
                        if (res.code === 'success') {
                            this.treeData.push(...this.treeDataAdapter(res.body.listdata))
                        } else {
                            this.$alert(res.message, { type: 'error' })
                            reject(res.message)
                        }
                        resolve(true)
                    })
                } else if (node.data && node.data.type === 'subOrg' && node.childNodes.length === 0 && node.data.olevel === 2 && (this.binding.value === 'allNode' || this.binding.value === 'curOrgNode')) {
                    const listdataUrl = 'base/organMgr/queryLinkManByPager?orgId=' + node.data.id
                    const pager = { pageNum: 1, pageSize: 10000 }

                    this.$app.listdata(listdataUrl, pager).then((res) => {
                        if (res.code === 'success') {
                            this.treeData = this.treeDataAdapter(res.body.pageInfo.list).concat(this.treeData)
                            resolve(true)
                            if (res.body.pageInfo.list.length === 0) {
                                setTimeout(() => {
                                    node.isLeaf = false
                                }, 0)
                            }
                        } else {
                            this.$alert(res.message, { type: 'error' })
                            reject(res.message)
                        }
                    })
                } else {
                    resolve(true)
                }
            }).then((res) => {
                if (res) {
                    let children = []
                    if (node.data && node.data.children) {
                        children = node.data.children
                        if (_this.selectedNodes.length > 0 && children.length > 0) {
                            _this.selectedNodes.forEach((item) => {
                                children.forEach((val) => {
                                    if (item.id === val.id && item.orgFullId === val.orgFullId) {
                                        _this.defaultCheckedKeys.push(val[_this.nodeKey])
                                    }
                                })
                            })
                        }
                    } else if (node.level === 0) {
                        children = this.getChildren(_this.treeData, null)
                        if (children.length === 1 && this.defaultExpandedKeys.length === 0) {
                            this.defaultExpandedKeys.push(children[0][_this.nodeKey])
                        }
                    } else {
                        children = this.getChildren(_this.treeData, node.data)
                    }
                    loadResolve(children)

                    if (children.length > 0) {
                        setTimeout(() => {
                            if (node.data && (node.data.olevel === 1 || node.data.orgLevel === 1) && (this.binding.value === 'allStaff' || this.binding.value === 'staffExt')) {
                                node.data.children = children
                                this.updateChildren(node.data)
                            }

                            this.selectedNodes.forEach((selectedNode) => {
                                this.$refs.orgTree.setChecked(selectedNode, true, false)
                            })
                        }, 0)
                    }
                }
            })
        },
        getChildren(treeData, nodeData) {
            const children = []
            if (treeData.length === 0) return children
            if (!nodeData) {
                // 查询根节点列表
                let firstPid = treeData[0].pId
                let level1Count = 0
                let topLevel = 5
                const treeNodeIds = []
                if (this.binding.value === 'staff' || this.binding.value === 'jobPositionStaff' || this.binding.value === 'workgroupStaff' || this.binding.value === 'wfNodeUser' || this.binding.value === 'rootorg') {
                    const suborgList = treeData.filter((node) => {
                        if (node.type === 'treeNode') {
                            treeNodeIds.push(node.id) // 目录树节点id
                        }
                        if (node.orgLevel < topLevel) {
                            topLevel = node.orgLevel
                        }
                        if (this.binding.value === 'wfNodeUser' && (node.orgLevel === 1 || node.olevel === 1)) {
                            // 通过asyncLoadingUsers异步加载的节点级别
                            level1Count++
                            return true
                        } else if (this.binding.value === 'staff' && node.olevel === 1) {
                            return this.el.attrs['org-self'] === 'true' || this.el.attrs['org-self'] === true
                        } else {
                            return node.type === 'subOrg' || node.orgLevel > 1 || node.olevel > 1 || node.type === 'treeNode'
                        }
                    })
                    suborgList.sort((a, b) => {
                        return a.orgLevel - b.orgLevel
                    })

                    if (suborgList.length > 0) {
                        firstPid = suborgList[0].pId
                    } else {
                        firstPid = null
                    }
                }

                for (let i = 0; i < treeData.length; i++) {
                    const tnode = treeData[i]

                    if (level1Count > 1 && treeData[0].type !== 'treeNode') {
                        if (tnode.orgLevel === 1 || tnode.olevel === 1) {
                            children.push(tnode)
                        }
                    } else if (!firstPid || tnode.orgLevel === topLevel || tnode.pId === firstPid || tnode.parentId === firstPid || (this.binding.value === 'rootorg' && treeNodeIds.length === 0)) {
                        children.push(tnode)
                    }
                }
            } else {
                // 查询nodeData的子节点列表
                for (let i = 0; i < treeData.length; i++) {
                    const tnode = treeData[i]
                    if ((tnode.pId || tnode.parentID || tnode.parentId || tnode.orgId || tnode.groupId) === nodeData.id) {
                        children.push(tnode)

                        if ((!this.lazy || this.binding.value === 'allStaff' || this.binding.value === 'staffExt') && !tnode.personId && !tnode.children) {
                            tnode.children = this.getChildren(treeData, tnode)
                        } else if ((this.selectByTabsActiveName === 'byJobPosition' || this.selectByTabsActiveName === 'byWorkgroup') && (tnode.orgLevel === 1 || tnode.olevel === 1)) {
                            //按群组、按岗位，关联主机构下的群组、岗位
                            tnode.children = this.getChildren(treeData, tnode)
                        }
                    }
                }
                if (this.binding.value.toUpperCase().indexOf('STAFF') !== -1 || this.binding.value === 'wfNodeUser' || this.binding.value === 'rootorg') {
                    if (children.length === 0 && (nodeData.type === 'subOrg' || nodeData.orgLevel > 1 || nodeData.olevel > 1 || (this.binding.value === 'wfNodeUser' && nodeData.orgLevel === 1) || (this.binding.value.toUpperCase().indexOf('STAFF') !== -1 && (nodeData.olevel === 1 || nodeData.orgLevel === 1)))) {
                        children.push({ title: '无', name: '无', disabled: true, personId: 'null' })
                    }
                }
            }

            return children
        },
        updateChildren(node) {
            let treeNode = this.$refs.orgTree.getNode(node.id)
            if (treeNode && !treeNode.loaded && node.children && node.children.length > 0) {
                this.$refs.orgTree.updateKeyChildren(node.id, node.children)
                this.$nextTick(() => {
                    treeNode = this.$refs.orgTree.getNode(node.id)
                    treeNode.loaded = true
                })
            }

            node.children.forEach((childNode) => {
                if (childNode.children) {
                    this.updateChildren(childNode)
                }
            })
        },
        searchTreeNode() {
            this.searchDoing = false
            this.searchedData = null

            const _this = this
            this.$nextTick(() => {
                if (!this.lazy || !this.searchkey) {
                    if (this.lazy && this.showSelectByTabs) {
                        this.onSelectByTabsHandleClick(this.selectByTabsActiveName)
                    } else {
                        this.$refs.orgTree.filter(this.searchkey)
                    }
                } else {
                    const searchedData = []

                    new Promise((resolve, reject) => {
                        let searchStaff = false
                        let searchNode = false
                        if (this.binding.value === 'allStaff' || this.binding.value === 'staffExt' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode') {
                            let listdataUrl = 'base/organMgr/queryLinkManByPager'
                            const orgTree = this.$refs.orgTree
                            if (orgTree.root.childNodes.length === 1) {
                                const rootNode = orgTree.root.childNodes[0].data
                                if (rootNode.type === 'rootOrg' || rootNode.type === 'subOrg') {
                                    listdataUrl += '?orgId=' + rootNode.id
                                } else if (rootNode.type === 'treeNode') {
                                    listdataUrl += '?nodeId=' + rootNode.id
                                }
                            }

                            const pager = { pageNum: 1, pageSize: 100, searchMap: {} }
                            pager.searchAndOr = 'or'
                            pager.searchMap['name'] = this.searchkey
                            pager.searchMap['account'] = this.searchkey
                            pager.searchMap['mobile'] = this.searchkey
                            pager.searchMap['positionName'] = this.searchkey

                            this.$app.listdata(listdataUrl, pager).then((res) => {
                                if (res.code === 'success') {
                                    searchedData.push(..._this.treeDataAdapter(res.body.pageInfo.list))
                                }
                                searchStaff = true
                                if (searchStaff && searchNode) resolve(true)
                            })
                        } else {
                            searchStaff = true
                        }

                        if (this.binding.value === 'allOrg' || this.binding.value === 'allNode' || this.binding.value === 'curOrgNode' || this.binding.value === 'suborgExt') {
                            const reqParams = { method: 'GET', url: 'base/organMgr/findTreeNodeVOListByKeyword', params: { keyword: this.searchkey } }

                            this.$http(reqParams).then((res) => {
                                if (res.code === 'success') {
                                    searchedData.push(...this.treeDataAdapter(res.body.listdata))
                                }
                                searchNode = true
                                if (searchStaff && searchNode) resolve(true)
                            })
                        } else {
                            searchNode = true
                        }
                        if (searchStaff && searchNode) resolve(true)
                    }).then((res) => {
                        _this.searchDoing = true
                        _this.searchedData = searchedData
                        setTimeout(() => {
                            this.selectedNodes.forEach((selectedNode) => {
                                this.$refs.searchOrgTree.setChecked(selectedNode, true, false)
                            })
                        }, 100)
                    })
                }
            })
        },
        getPrevSelected() {
            let pSelected = ''
            if (this.vnode.data.attrs['old-value']) {
                pSelected = this.vnode.data.attrs['old-value']
            } else if (this.el.value !== undefined && this.el.value !== null && this.el.value !== '') {
                pSelected = this.el.value
            } else if (this.vnode.data.model.value && !this.vnode.data.attrs['value-ids-field']) {
                pSelected = this.vnode.data.model.value
            } else {
                let model = this.vnode.data.model.expression.split('.')
                if (this.vnode.data.attrs['value-ids-field']) {
                    model = this.vnode.data.attrs['value-ids-field'].split('.')
                }
                if (this.vnode.context[model[0]]) {
                    if (model.length === 2) {
                        pSelected = this.vnode.context[model[0]][model[1]] || ''
                    } else if (model.length === 3) {
                        pSelected = this.vnode.context[model[0]][model[1]][model[2]] || ''
                    } else {
                        pSelected = this.vnode.context[model[0]] || ''
                    }
                }
            }

            if (this.showSelectByTabs && this.selectedNodes.length > 0) {
                this.selectedNodes.forEach((item) => {
                    if (pSelected !== '') pSelected += ','
                    pSelected += item.id
                })
            }

            pSelected = pSelected.replace(/、/g, ',').replace(/;/g, ',').replace(/，/g, ',').replace(/\r\n/g, ',')
            if (this.el.attrs['separate'] && pSelected.indexOf(this.el.attrs['separate']) !== -1) {
                return pSelected.split(this.el.attrs['separate'])
            } else {
                return pSelected.split(',')
            }
        },
        filterOrgTreeNode(value, data) {
            if (!value) return true

            return data.title.indexOf(value) !== -1
        },
        isLeafNode(data, node) {
            if (data.collapse) {
                delete data.children
                return true
            } else if (this.binding.value === 'workgroup' || this.binding.value === 'jobPosition') {
                return true
            } else if (this.binding.value === 'rootorg' && data.type === 'rootOrg') {
                return true
            } else if (this.binding.value === 'suborg' || this.binding.value === 'allOrg' || this.binding.value === 'suborgExt') {
                if (data.type && data.type !== 'subOrg') {
                    return false
                } else if (data.orgLevel === 1) {
                    return false
                } else {
                    const children = this.treeData.filter((treeNode) => {
                        return (treeNode.parentId || treeNode.parentID) === data.id
                    })
                    return children.length === 0
                }
            } else if (data.personId) return true
        },
        // 节点点击事件
        onTreeNodeClick(data, nodeData, treeNode) {
            if (nodeData.isLeaf && !data.disabled) {
                if (this.searchDoing) {
                    this.$refs.searchOrgTree.setChecked(nodeData, !nodeData.checked, false)
                    this.onTreeNodeCheck(data, { checkedKeys: this.$refs.searchOrgTree.getCheckedKeys() })
                } else {
                    this.$refs.orgTree.setChecked(nodeData, !nodeData.checked, false)
                    this.onTreeNodeCheck(data, { checkedKeys: this.$refs.orgTree.getCheckedKeys() })
                }
            }
        },
        onTreeNodeExpand(data, nodeData, treeNode) {
            if (nodeData.childNodes.length > 0) {
                this.selectedNodes.forEach((selectedNode) => {
                    this.$refs.orgTree.setChecked(selectedNode, true, false)
                })
            }
        },
        onTreeNodeCheck(data, checked) {
            let orgTree = this.$refs.orgTree
            // console.log(data, 'data')
            if (this.searchDoing) orgTree = this.$refs.searchOrgTree
            if (!this.multiple || this.el.attrs['todo-mode'] === '6') {
                this.selectedNodes = []
                orgTree.setCheckedKeys([])
                if (checked.checkedKeys.indexOf(data[this.nodeKey]) !== -1) {
                    orgTree.setChecked(data, true, false)
                } else {
                    orgTree.setChecked(data, false, false)
                }
            }

            if (this.checkStrictly || this.onebyone || this.selectedOrderBy === 'selectedIndex') {
                if (checked.checkedKeys.indexOf(data[this.nodeKey]) !== -1) {
                    if (this.onebyone) {
                        for (let i = 0; i < this.selectedNodes.length; i++) {
                            if (data.groupId && this.selectedNodes[i].groupId === data.groupId) {
                                orgTree.setChecked(this.selectedNodes[i], false, false)
                                this.selectedNodes.splice(i--, 1)
                            } else if (data.orgFullId && data.orgFullId.indexOf('-') !== -1 && this.selectedNodes[i].orgFullId && this.selectedNodes[i].orgFullId.indexOf('-') !== -1) {
                                if (data.orgFullId.split('-')[1] === this.selectedNodes[i].orgFullId.split('-')[1]) {
                                    orgTree.setChecked(this.selectedNodes[i], false, false)
                                    this.selectedNodes.splice(i--, 1)
                                }
                            }
                        }
                    }
                    const selected = this.selectedNodes.filter((node) => {
                        return node.id === data.id || (data.personId && data.personId === node.personId)
                    })
                    if (selected.length === 0) {
                        this.selectedNodes.push(data)
                    }
                } else {
                    for (let i = 0; i < this.selectedNodes.length; i++) {
                        if (this.selectedNodes[i].id === data.id) {
                            this.selectedNodes.splice(i--, 1)
                        }
                    }
                }
            } else if (this.lazy && (data.olevel === 1 || data.orgLevel === 1) && (this.binding.value === 'allStaff' || this.binding.value === 'staffExt')) {
                new Promise(async (resolve, reject) => {
                    const treeNode = this.$refs.orgTree.getNode(data.id)
                    if (!treeNode.loaded) {
                        await this.loadNode(treeNode, resolve)
                        resolve(false)
                        setTimeout(() => {
                            this.$refs.orgTree.setChecked(data, true, true)
                            this.onTreeNodeCheck(data, checked)
                        }, 0)
                    } else {
                        resolve(true)
                    }
                }).then((res) => {
                    if (res) {
                        this.updateSelectdNodes(data, orgTree)
                    }
                })
            } else {
                this.updateSelectdNodes(data, orgTree)
            }
        },
        // 修改选中数据，右侧显示
        updateSelectdNodes(data, orgTree) {
            this.$nextTick(() => {
                if (!this.showSelectByTabs) {
                    this.selectedNodes = []
                } else {
                    const treeNode = this.$refs.orgTree.getNode(data.id)
                    if (treeNode && !treeNode.check) {
                        for (let i = 0; i < this.selectedNodes.length; i++) {
                            if (this.selectedNodes[i].id === data.id || this.selectedNodes[i].groupId === data.id || (this.selectedNodes[i].orgFullId && this.selectedNodes[i].orgFullId.indexOf(data.id) !== -1)) {
                                this.selectedNodes.splice(i--, 1)
                            }
                        }
                    }
                }

                const checkedFolderNodeKeys = []
                const leafOnly = !(data.collapse || (data.passenger && data.passenger.collapse)) // data.collapse：true表示选中项不需要展开文件夹
                const checkedNodes = orgTree.getCheckedNodes(leafOnly, false)

                checkedNodes.forEach((node) => {
                    if (!node.disabled) {
                        if (!node.personId) {
                            checkedFolderNodeKeys.push(node.id)
                        }
                        const selected = this.selectedNodes.filter((data) => {
                            return node.id === data.id || (node.personId && data.personId === node.personId)
                        })

                        if (selected.length === 0) {
                            if (!node.personId && checkedFolderNodeKeys.indexOf(node.parentId) === -1) {
                                this.selectedNodes.push(node)
                            } else if (node.personId && checkedFolderNodeKeys.indexOf(node.orgId) === -1 && checkedFolderNodeKeys.indexOf(node.groupId) === -1) {
                                this.selectedNodes.push(node)
                            }
                        }
                    }
                })
            })
        },
        removeSelectedNode(removeNode) {
            this.$refs.orgTree.setChecked(removeNode, false, false)
            if (this.searchDoing) {
                this.$refs.searchOrgTree.setChecked(removeNode, false, false)
            }

            for (let i = 0; i < this.selectedNodes.length; i++) {
                if (this.selectedNodes[i].id === removeNode.id) {
                    this.selectedNodes.splice(i--, 1)
                }
            }
        },
        showQuery() {
            let flag = false
            switch (this.binding.value) {
                case 'staffExt':
                    flag = true
                    break
                case 'allStaff':
                    flag = true
                    break
                case 'curOrgNode':
                    flag = true
                    break
                case 'allNode':
                    flag = true
                    break
                default:
                    flag = false
            }
            return flag
        },
        onSelectByTabsHandleClick(val) {
            // 机构全体人员，按机构、按岗位、按群组标签点击
            const _this = this
            _this.treeData = []
            _this.searchkey = ''
            _this.tabType = val
            _this.defaultCheckedKeys = []
            _this.lazy = false
            _this.switchTabPanel = true
            let treeData = null

            if (val === 'byWorkgroup') {
                treeData = this.byWgTreeData
            } else if (val === 'byJobPosition') {
                treeData = this.byJbTreeData
            } else if (val === 'byPrivateWorkgroup') {
                treeData = this.byPrivateWorkgroupData
            } else {
                treeData = JSON.parse(JSON.stringify(this.byOrgTreeData))
                _this.lazy = this.isLazy()
            }

            new Promise(async (resolve, reject) => {
                if (!treeData) {
                    const orgCodes = []
                    _this.byOrgTreeData.forEach((item) => {
                        if ((item.isRealOrg === 1 && item.orgLevel === 1) || item.type === 'rootOrg') {
                            orgCodes.push(item.code || item.ocode)
                        }
                    })
                    if (orgCodes.length === 0) {
                        let orgCode = this.el.attrs['root-org-code']
                        if (orgCode) {
                            orgCodes.push(orgCode)
                        }
                    }
                    if (orgCodes.length === 0) {
                        orgCodes.push(_this.loginUser.orgCode)
                    }

                    const reqParams = {
                        method: 'POST',
                        url: 'base/organMgr/findLinkManByGroupType',
                        params: { orgCodes: orgCodes.join(), byType: val }
                    }
                    this.$http(reqParams).then((res) => {
                        if (res.code === 'success') {
                            let listdata = []
                            if (val === 'byWorkgroup' || val === 'byJobPosition') {
                                if (orgCodes.length > 1) {
                                    listdata = JSON.parse(JSON.stringify(this.byOrgTreeData)) //按机构目录分层次展示工作群组、工作岗位
                                }
                                listdata.push(...res.body.listdata)
                            } else {
                                listdata = res.body.listdata
                            }

                            treeData = this.treeDataAdapter(listdata)
                            resolve(true)
                        } else {
                            this.$alert(res.message, { type: 'error' })
                            resolve(false)
                        }
                    })
                } else {
                    resolve(true)
                }
            }).then((res) => {
                if (res) {
                    if (this.showSelectByTabs && this.selectedNodes.length > 0) {
                        let pSelected = ''
                        this.selectedNodes.forEach((item) => {
                            if (pSelected !== '') pSelected += ','
                            pSelected += item.id
                        })
                        if (pSelected !== '') {
                            if (_this.lazy) {
                                this.lazyLoadDefaultChecked(pSelected.split(','))
                            } else {
                                const pSelectFun = (treeData) => {
                                    treeData.forEach((item) => {
                                        if (pSelected.indexOf(item.id) !== -1) {
                                            const selected = this.selectedNodes.filter((data) => {
                                                return item.id === data.id || (item.personId && data.personId === item.personId)
                                            })
                                            if (selected.length === 0) {
                                                this.selectedNodes.push(item)
                                            }
                                            item.checked = true
                                        }
                                        if (item.children && item.children.length > 0) pSelectFun(item.children)
                                    })
                                }

                                pSelectFun(treeData)
                                const ids = pSelected.split(',')

                                _this.defaultCheckedKeys = []
                                ids.forEach((id) => {
                                    _this.defaultCheckedKeys.push(id)
                                })
                            }
                        }
                    }
                    _this.treeData = treeData
                    _this.switchTabPanel = false
                }
            })
        },
        addFormShow() {
            if (this.selectedNodes.length > 0) {
                this.addFormVisible = true
            } else {
                this.$alert('请输入常用组名称！', this.$tx('common.operationTip', '操作提示'), { type: 'error' })
            }
        },
        // 添加常用组
        addForm() {
            if (this.commonGroupName) {
                this.$confirm('是否确认添加常用组？', this.$tx('common.confirmOperate', '确认操作'), { type: 'warning' })
                    .then(() => {
                        this.$app.addNew('base/workGroup/addNew').then((res1) => {
                            const vo = res1.body.vo
                            vo.groupType = 1
                            vo.creator = this.loginUser.personName
                            vo.creatorPersonId = this.loginUser.personId
                            vo.orgCode = this.loginUser.orgCode
                            vo.orgName = this.loginUser.orgName
                            vo.name = this.commonGroupName
                            let selected = ''
                            this.selectedNodes.forEach(function (item) {
                                selected += item.orgFullName.substring(item.orgFullName.indexOf('-') + 1).replace('-', '\\') + item.name + '/' + item.account + '\r\n'
                            })
                            vo.members = selected
                            vo.status = 1
                            vo.orderNo = '1000'
                            vo.passenger.members = this.selectedNodes
                            this.$app.insert('base/workGroup/insert', vo).then((resp) => {
                                if (resp.code === 'success') {
                                    this.$message.success(resp.message)
                                    this.addFormVisible = false
                                    this.commonGroupName = ''
                                    this.byPrivateWorkgroupData = null
                                    if (this.selectByTabsActiveName === 'byPrivateWorkgroup') this.onSelectByTabsHandleClick(this.selectByTabsActiveName)
                                } else {
                                    this.$alert(resp.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                                }
                            })
                        })
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                this.$alert(this.$tx('ecwapp.SelectDialog.inputCommonGroup', '请输入常用组名称！'), this.$tx('common.operationTip', '操作提示'), { type: 'error' })
            }
        },
        // 解密
        dataDecrypt(list) {
            const _this = this
            return new Promise(async (resolve, reject) => {
                const data = []
                let enMode = 'sm4'
                for (let i = 0; i < list.length; i++) {
                    // 只解密加密的对象
                    for (const key in list[i]) {
                        if (typeof list[i][key] === 'string' && list[i][key].indexOf('{') > -1) {
                            const value = JSON.parse(list[i][key])
                            enMode = value.enMode //加密方法
                            list[i].dataIndex = i
                            data.push(list[i])
                        }
                    }
                }

                if (data.length > 0) {
                    const res = await _this.$http({
                        url: '/common/dataDecrypt',
                        method: 'post',
                        headers: { 'Content-Type': 'application/json' },
                        data: { enMode: enMode, data: JSON.stringify(data) }
                    })
                    if (res.code === 'success') {
                        if (_this.multiple) {
                            const newData = JSON.parse(res.body.data)
                            //保留原list元素顺序不变
                            newData.forEach((item) => {
                                list[item.dataIndex] = item
                            })
                        } else {
                            list[0] = JSON.parse(res.body.data)
                        }
                        resolve(true)
                    }
                } else {
                    resolve(true)
                }
            })
        },
        submitForm() {
            const _this = this
            const model = this.vnode.data.model.expression.split('.')
            new Promise((resolve, reject) => {
                const prevSelected = this.getPrevSelected()

                if (this.selectedNodes.length === 0 && prevSelected.length > 0) {
                    this.$confirm('是否确认清除已选？', this.$tx('common.confirmOperate', '确认操作'), { type: 'warning' })
                        .then(() => {
                            resolve(true)
                        })
                        .catch((err) => {
                            reject(err)
                        })
                } else {
                    resolve(true)
                }
            }).then(async () => {
                const selectedNodes = []
                await _this.dataDecrypt(_this.selectedNodes)
                _this.selectedNodes.forEach((node) => {
                    if ((node.collapse || node.passenger.collapse) && !node.personId && node.children) {
                        node.children.forEach((tnode) => {
                            if (!tnode.children) {
                                selectedNodes.push(tnode)
                            } else {
                                tnode.children.forEach((ttnode) => {
                                    if (!ttnode.children) {
                                        selectedNodes.push(ttnode)
                                    } else {
                                        selectedNodes.push(...ttnode.children)
                                    }
                                })
                            }
                        })
                    } else {
                        selectedNodes.push(node)
                    }
                })
                if (_this.vnode.context[_this.callback] !== undefined) {
                    await _this.vnode.context[_this.callback](selectedNodes, _this.el.attrs)
                } else if (_this.vnode.context.$vnode.context[_this.callback] !== undefined) {
                    await _this.vnode.context.$vnode.context[_this.callback](selectedNodes, _this.el.attrs)
                } else if (_this.vnode.context.$vnode.context.$vnode.context[_this.callback] !== undefined) {
                    await _this.vnode.context.$vnode.context.$vnode.context[_this.callback](selectedNodes, _this.el.attrs)
                } else {
                    let selected = ''
                    selectedNodes.forEach(function (node) {
                        if (selected !== '') selected += '、'
                        selected += node.name
                    })

                    if (model[0] === 'formItem' && this.vnode.context['valueChange'] !== undefined) {
                        this.vnode.context['valueChange'](selected)
                    }
                    if (this.vnode.context[model[0]]) {
                        if (model.length === 2) {
                            this.vnode.context.$set(this.vnode.context[model[0]], model[1], selected)
                        } else {
                            this.vnode.context.$set(this.vnode.context, model[0], selected)
                        }
                    }
                }

                if (this.vnode.context[model[0]]) {
                    if (model.length === 2) {
                        this.vnode.data.model.value = this.vnode.context[model[0]][model[1]] || ''
                    } else if (model.length === 3) {
                        this.vnode.data.model.value = this.vnode.context[model[0]][model[1]][model[1]] || ''
                    } else {
                        this.vnode.data.model.value = this.vnode.context[model[0]] || ''
                    }

                    if (model[0] === 'formItem' && this.vnode.context['valueChange'] !== undefined) {
                        this.vnode.context['valueChange'](this.vnode.data.model.value)
                    }
                }

                this.vnode.context.$forceUpdate()
                this.closeDialog()
            })
        },
        closeDialog() {
            this.dialogFormVisible = false
            this.loading = false
            this.winWidth = 623
            this.byOrgTreeData = null
            this.byWgTreeData = null
            this.byJbTreeData = null
            this.byPrivateWorkgroupData = null
            this.el = null
            this.binding = null
            this.vnode = null
            this.dialogName = null
            this.treeData = null
            this.selectedNodes = []
            this.rootTreeData = null
            this.selectRootOrg = ''
            this.rootOrgList = []
            this.subOrgList = {}
            this.searchkey = ''
            this.tabType = ''
            this.showSelectByTabs = false
            if (window.fontMagnify !== undefined) window.fontMagnify = false
        }
    }
}
</script>
<style scoped lang="scss">
.search-input-container {
    padding-bottom: 8px;

    /deep/ .el-input-group__prepend {
        width: 100px;
        background-color: #fff;
        color: #333;
        border-bottom-right-radius: 0px;
        border-top-right-radius: 0px;
    }
}

.ztree-container {
    height: 350px;

    /deep/ .el-tabs--top {
        margin-top: 0px;

        .el-tabs__header {
            margin: 0px;
            border-bottom: solid 1px #dfe6ec;
        }

        .el-tabs__nav-wrap::after {
            height: 0px;
        }
    }

    .el-tree {
        overflow-x: hidden;
    }

    /deep/ .el-checkbox .is-disabled {
        display: none;
    }

    .selected-title {
        font-weight: 600;
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 32px;
        margin-bottom: 6px;
    }

    .selectedNodes {
        width: 100%;
        padding: 10px;

        .selectedNode {
            background-color: #f1f4f7;
            margin-bottom: 4px;
            padding: 6px 8px;

            .node-text {
                width: calc(100% - 15px);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .el-icon-close {
                float: right;
                cursor: pointer;
                color: #ff0000;
                margin-top: -14px;
            }
        }
    }
}

.treeNode {
    border: 1px solid #dfe6ec;

    .el-scrollbar {
        height: 300px;
    }

    .no-search-input {
        height: 327px;
        margin-top: 10px;
    }

    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    .tree-node-icon {
        i {
            margin-right: 7px;
            margin-left: -7px;
            font-size: var(--portalFontSize14);
        }
    }
}

.searchdoing {
    /deep/ .el-loading-mask {
        background-color: rgba(255, 255, 255, 1);
    }
}
</style>
<style>
.orgTreeDialog {
    min-width: 625px;
}
</style>
